import React, { useEffect, Fragment } from 'react'
import { useConfiguration } from '../../hooks/useConfiguration'

export const ConfigurationProvider: React.FC<any> = ({ children }) => {
  const { getConfiguration } = useConfiguration()

  useEffect(() => {
    getConfiguration()
  }, [])

  return <Fragment>{children}</Fragment>
}
